<template lang="pug">
.v-brief-advantages.brief-advantages(v-if="data" :class="[view ? 'brief-advantages--' + view : '']" :id="data?.id")
	component.brief-advantages__item(v-for="item in data.items" :is="item.link ? 'a' : 'div'" :href="item.link ? item.link : ''" :style="{backgroundImage: `url('${item.backgroundImage}')`, backgroundColor: item.backgroundColor}")
		.brief-advantages__item-top
			.brief-advantages__item-title(v-if="item.title" v-html="item.title")
			img.brief-advantages__item-icon(v-if="item.icon" :src="item.icon")
		.brief-advantages__item-text(v-if="item.text" v-html="item.text")
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";

export default {
	mixins: [
		sourceMixin
	],

	props: {
		view: {
			type: String,
			default: null
		}
	},

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>